"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PionexForbiddenMccList = void 0;
exports.PionexForbiddenMccList = [
    "IRN",
    "BDI",
    "CAF",
    "CUB",
    "IRQ",
    "LBN",
    "LBY",
    "SOM",
    "SSD",
    "SDN",
    "SYR",
    "VEN",
    "YEM",
    "AFG",
    "COD",
    "ZWE",
    "SGP",
    "CHN",
    "PRK",
    "USA",
];
